import { render } from "./CarouselUnitUpgrade.vue?vue&type=template&id=77968950"
import script from "./CarouselUnitUpgrade.vue?vue&type=script&lang=js"
export * from "./CarouselUnitUpgrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselUnitUpgrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77968950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77968950', __exports__)) {
    api.reload('77968950', __exports__)
  }
  
  module.hot.accept("./CarouselUnitUpgrade.vue?vue&type=template&id=77968950", () => {
    api.rerender('77968950', render)
  })

}


export default __exports__